// src/styles/GlobalStyles.js

import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    // COULEURS OFFICIELLES DRAPEAU TCHAD - Version améliorée
    --primary-blue: #002664;
    --primary-blue-dark: #001a45;
    --primary-blue-light: #003d99;
    --secondary-red: #C8102E;
    --accent-gold: #FECA00;
    --accent-gold-dark: #d4a700;
    --accent-green: #009639;
    
    // Nouvelles couleurs d'accent
    --gradient-blue: linear-gradient(135deg, #002664 0%, #004d8f 100%);
    --gradient-gold: linear-gradient(135deg, #FECA00 0%, #ffd940 100%);
    --glass-white: rgba(255, 255, 255, 0.95);
    --glass-blue: rgba(0, 38, 100, 0.85);
    
    --white: #FFFFFF;
    --off-white: #FAFBFC;
    --text-dark: #1a1a2e;
    --text-medium: #4a4a68;
    --text-light: #6b7280;
    --background-light: #f8fafc;
    --border-light: #e2e8f0;
    
    --shadow-xs: 0 1px 2px rgba(0, 38, 100, 0.05);
    --shadow-sm: 0 2px 8px rgba(0, 38, 100, 0.08);
    --shadow-md: 0 4px 20px rgba(0, 38, 100, 0.12);
    --shadow-lg: 0 12px 40px rgba(0, 38, 100, 0.18);
    --shadow-xl: 0 20px 60px rgba(0, 38, 100, 0.22);
    
    --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --font-secondary: 'Montserrat', 'Arial Black', sans-serif;
    
    --transition-fast: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    --transition-slow: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 24px;
    --radius-full: 9999px;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--font-primary);
    color: var(--text-dark);
    background: var(--background-light);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html.is-translated,
  body.is-translated {
    overflow-x: hidden;
  }

  body.is-translated h1,
  body.is-translated h2,
  body.is-translated h3,
  body.is-translated h4,
  body.is-translated h5,
  body.is-translated h6,
  body.is-translated p,
  body.is-translated li,
  body.is-translated a,
  body.is-translated button,
  body.is-translated label,
  body.is-translated span {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  body.is-translated a,
  body.is-translated button {
    white-space: normal;
    line-height: 1.35;
  }

  body > .skiptranslate,
  .goog-te-banner-frame,
  .goog-te-banner-frame.skiptranslate,
  .goog-te-balloon-frame,
  .goog-te-menu-frame,
  .goog-te-ftab-frame,
  iframe.goog-te-banner-frame,
  iframe.skiptranslate,
  .VIpgJd-ZVi9od-ORHb,
  .VIpgJd-ZVi9od-ORHb-OEVmcd,
  .VIpgJd-ZVi9od-aZ2wEe-wOHMyf,
  .VIpgJd-ZVi9od-aZ2wEe-OiiCO,
  .VIpgJd-ZVi9od-l4eHX-hSRGPd,
  .VIpgJd-ZVi9od-xl07Ob-OEVmcd {
    display: none !important;
    visibility: hidden !important;
  }

  #goog-gt-tt,
  .goog-tooltip,
  .goog-tooltip:hover {
    display: none !important;
  }

  .goog-text-highlight {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  html.translated-ltr,
  html.translated-rtl,
  body.translated-ltr,
  body.translated-rtl {
    top: 0 !important;
  }

  body {
    top: 0 !important;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    cursor: pointer;
    border: none;
    font-family: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  // Animations globales
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  .animate-fadeInUp {
    animation: fadeInUp 0.6s ease-out forwards;
  }

  @media (max-width: 1200px) { html { font-size: 15px; } }
  @media (max-width: 768px) { html { font-size: 14px; } }
  @media (max-width: 480px) { html { font-size: 13px; } }
`;
